// The map open now, for what the board does from outside it: the board's keys reach it first (Tab, Enter,
// Space, Delete and the arrows act on the selected idea), and See everything and a new widget's place take
// in the ground its ideas cover. Light on purpose: the main app loads it, never the map.

import type { ID } from "../../../shared/types";

export interface LiveMap {
  boardId: ID;
  /** a key the map acts on, before the board's own shortcuts; true when it took it */
  key(e: KeyboardEvent): boolean;
  /** the ground the map's ideas cover now, in the board's units */
  bounds(): { x: number; y: number; w: number; h: number } | null;
}

let live: LiveMap | null = null;

export function setLiveMap(m: LiveMap | null) {
  live = m;
}

export function liveMap(boardId?: ID | null): LiveMap | null {
  return live && (!boardId || live.boardId === boardId) ? live : null;
}

/** The rects See everything fits, with the ground the open map covers. */
export function withMap<R extends { x: number; y: number; w: number; h: number }>(rects: R[]): Array<R | { x: number; y: number; w: number; h: number }> {
  const b = live?.bounds();
  return b ? [...rects, b] : rects;
}
